import { TrackingPreference } from './TrackingPreference';
import { RefTrackingPreference } from './RefTrackingPreference';

export class CarrierEdit {
  refTrackingPreferences: RefTrackingPreference[];
  trackingPreference: TrackingPreference;
}
